import type {
  BatchAddMappingReportItemReq,
  CompanyLmListReq,
  CompanyReportItemPageReq,
  ConfirmReminderVo,
  DailyReportCategoryListReq,
  DailyReportCategoryListVo,
  DailyReportDetailReq,
  DailyReportDetailVo,
  DailyReportListReq,
  DailyReportListVo,
  DailyReportProductListReq,
  DailyReportProductListVo,
  DictDetailDtoObject,
  LmAdminReportReq,
  LmCategoryPropertyValueVo,
  LmCategoryReportPageReq,
  LmCategoryReportPageVo,
  LmContributionPageReq,
  LmContributionPageReqCreate,
  LmCountVo,
  LmMemberPageReq,
  LmMktPageReq,
  LmMktPageVo,
  LmMktPriceCountReq,
  LmMktPriceCountVo,
  LmReportItemVo,
  LmReportPriceReq,
  LmReportReq,
  LmSpuMatchReq,
  LmSpuMatchVo,
  MappingTempPageReq,
  MappingTempPageVo,
  MappingTempUpdateReq,
  PageVoCompanyLmListVo,
  PageVoCompanyReportItemVo,
  PageVoLmActivityLevelVo,
  PageVoLmAttendanceCountVo,
  PageVoLmMemberPageVo,
  PageVoLmReportCountVo,
  PageVoLmReportItemManageVo,
  PageVoProductMappingPageVo,
  ProductMappingPageReq,
  ProductMappingPageVo,
  ProductMappingSaveReq,
  PropertySearchReq,
  ReportCountVo,
  ReportItemAddReq,
  ReportItemManagePageReq,
  ReportPageReq,
  ReportPageVo,
  ReportUpdateReq,
  ReportUpdateV2Req,
  SaveLmReportItemReq,
  ExportTaskReq,
  ExportTaskPopupVo,
  ExportTaskVo,
  PageVoExportTaskVo,
  ExportTaskPageReq,
  AccessStatusVo,
  RealtimeReq,
  PdfExportReq,
  LmCategoryVo,
  PageVoPeriodReportListVo,
  PeriodReportDateVo,
  PeriodReportListReq,
  PeriodReportDetailReq,
  PeriodReportCategoryListReq,
  PeriodReportProductListReq,
} from "types/openapi/lm";
import type { AppPaginationResponse, PaginationResponse } from "@/types/http";

import { downloadFile, get, post } from "@/http/axios";
/**
 * 模板提报下载
 * @returns
 */
export function downloadTemp(type: number) {
  return get({
    url: `/api/lm/alliance/file/download/${type}`,
  });
}
/**
 * 批量导入提报分页查询
 */
export function importReportPage(data: ReportPageReq) {
  return post<AppPaginationResponse<ReportPageVo[]>>({
    url: "/api/lm/alliance/report/page",
    data,
  });
}
/**
 * 批量提报提交
 */
export function importReportSubmit() {
  return get({
    url: "/api/lm/alliance/report/submit",
  });
}
/**
 * 删除导入问题数据
 */
export function deleteImportReport(id: number) {
  return get({
    url: `/api/lm/alliance/report/delete/${id}`,
  });
}

/**
 * 修改导入问题数据
 */
export function updateImportReport(data: ReportUpdateReq) {
  return post({
    url: "/api/lm/alliance/report/update",
    data,
  });
}
/**
 * 保存提报项
 */
export function saveReportItem(data: ReportItemAddReq[]) {
  return post({
    url: "/api/lm/alliance/saveReportItem",
    data,
  });
}
/**
 * 删除提报项
 */
export function deleteReportItem(data: any[]) {
  return post({
    url: "/api/lm/alliance/deleteReportItem",
    data,
    hiddenLoading: true,
  });
}
/**
 * 获取提报价格项
 */
export function getReportPriceItem(data: LmReportReq) {
  return post({
    url: "/api/lm/alliance/reportedItem",
    data,
  });
}

/**
 * 提报价格接口
 */
export function reportPrice(data: LmReportPriceReq) {
  return post({
    url: "/api/lm/alliance/reportPrice",
    data,
  });
}
/**
 * 查询企业加入的联盟列表(提报项筛选用)
 */
export function getJoinAllianceList(data: CompanyLmListReq) {
  return post<PageVoCompanyLmListVo>({
    url: "/api/lm/alliance/alliancePage",
    data,
    hiddenLoading: true,
  });
}

/**
 * 商品映射分页查询
 */
export function getProductMappingPage(data: ProductMappingPageReq) {
  return post<AppPaginationResponse<PageVoProductMappingPageVo[]>>({
    url: "/api/lm/alliance/mapping/page",
    data,
  });
}
/**
 * 商品映射新增
 */
export function addProductMapping(data: ProductMappingSaveReq) {
  return post({
    url: "/api/lm/alliance/mapping/save",
    data,
  });
}
/**
 * 商品映射编辑
 */
export function updateProductMapping(data: ProductMappingSaveReq) {
  return post({
    url: "/api/lm/alliance/mapping/update",
    data,
  });
}
/**
 * 删除商品映射
 */
export function deleteProductMapping(id: number) {
  return get({
    url: `/api/lm/alliance/mapping/delete/${id}`,
  });
}
/**
 * 商品名称校验
 */
export function checkProductName(productName: string, id?: number | null) {
  return get<boolean>({
    url: `/api/lm/alliance/mapping/checkProductName`,
    params: {
      id,
      productName,
    },
    hiddenLoading: true,
  });
}

export function templateDownload(type: number) {
  return downloadFile({
    url: `/api/lm/alliance/file/download/${type}`,
  });
}
/**
 * 获取计量单位
 */
export function getUnit() {
  return get<DictDetailDtoObject[]>({
    url: "/api/lm/alliance/base/getUnit",
    hiddenLoading: true,
  });
}
/**
 * 品类/品种某日提报分页数据
 */
export function getReportPage(data: LmCategoryReportPageReq) {
  return post<AppPaginationResponse<LmCategoryReportPageVo[]>>({
    url: "/api/lm/alliance/mkt/categoryReportPage",
    data,
  });
}
/**
 * 查询行情价分页
 */
export function getPricePage(data: LmMktPageReq) {
  return post<AppPaginationResponse<LmMktPageVo[]>>({
    url: "/api/lm/alliance/mkt/page",
    data,
  });
}

/**
 * 品类/品种7日提报分页数据
 */
export function categorySevenReportPage(data: LmMktPageReq) {
  return post<AppPaginationResponse<LmMktPageVo[]>>({
    url: "/api/lm/alliance/mkt/categorySevenReportPage",
    data,
  });
}
/**
 * PC联盟是否提报统计
 */
export function getReportCount(data: LmMktPriceCountReq) {
  return post<LmMktPriceCountVo>({
    url: "/api/lm/alliance/mkt/allianceCount",
    data,
  });
}

/**
 * 批量导入统计查询
 */
export function getBatchReportCount(data: LmMktPriceCountReq) {
  return post<LmMktPriceCountVo>({
    url: "/api/lm/alliance/report/count",
    data,
  });
}
/**
 * 获取提报项
 */
export function getReportedItem(data: LmReportReq) {
  return post<AppPaginationResponse<LmReportItemVo[]>>({
    url: "/api/lm/alliance/v2/reportedItem",
    data,
  });
}
/**
 * 获取提报价格项(统计)
 */
export function getReportedItemCount(data: LmReportReq) {
  return post<LmCountVo>({
    url: "/api/lm/alliance/v2/countItem",
    data,
  });
}
/**
 * 保存提报项(未提报状态)
 */
export function updateReportedItem(data: SaveLmReportItemReq) {
  return post({
    url: "/api/lm/alliance/saveReport",
    data,
  });
}
/**
 * 批量提报提交
 */
export function batchReportSubmit() {
  return get({
    url: "/api/lm/alliance/submit",
  });
}
/**
 * 筛选类目属性值列表
 */
export function getPropertyListBySearch(data: PropertySearchReq) {
  return post<AppPaginationResponse<LmCategoryPropertyValueVo[]>>({
    url: "/api/lm/alliance/base/propertyValueSearch",
    data,
  });
}
/**
 * 修改导入问题数据(根据提报项编码修改)
 */
export function updateImportData(data: ReportUpdateV2Req) {
  return post({
    url: "/api/lm/alliance/report/updateByReportCode",
    data,
  });
}
/**
 * 删除导入问题数据(通过MD5Str删除)
 */
export function deleteImportData(md5Str: string) {
  return get({
    url: `/api/lm/alliance/report/deleteByReportCode`,
    params: {
      md5Str,
    },
  });
}
/*
日报日期
*/
export function getReportDate() {
  return get({
    url: "/api/lm/alliance/daily/report/date",
  });
}

/**
 * 日报列表
 */
export function getReportList(data: DailyReportListReq) {
  return post<AppPaginationResponse<DailyReportListVo[]>>({
    url: "/api/lm/alliance/daily/report/list",
    data,
  });
}
/**
 * 日报明细
 */
export function getReportDetail(data: DailyReportDetailReq) {
  return post<DailyReportDetailVo>({
    url: "/api/lm/alliance/daily/report/detail",
    data,
  });
}
/**
 * 日报明细-大类(分页)
 */
export function getReportDetailCategory(data: DailyReportCategoryListReq) {
  return post<PaginationResponse<DailyReportCategoryListVo[]>>({
    url: "/api/lm/alliance/daily/report/category/list",
    data,
  });
}
/**
 * 日报明细-商品(分页)
 */
export function getReportDetailProduct(data: DailyReportProductListReq) {
  return post<PaginationResponse<DailyReportProductListVo[]>>({
    url: "/api/lm/alliance/daily/report/product/list",
    data,
  });
}

/**
 * 生成二维码
 */
export function generateQrCode(data?: any) {
  return post({
    url: "/api/lm/alliance/base/generate/wx/qrCode",
    data,
  });
}
/**
 * 批量添加映射商品为提报项
 */
export function batchAddMappingProduct(data: BatchAddMappingReportItemReq) {
  return post({
    url: "/api/lm/alliance/report/item/batchAddReportItem",
    data,
  });
}
/**
 * 联盟活跃度列表(分页)
 */
export function getAllianceActiveList(data: LmContributionPageReq) {
  return post<PageVoLmActivityLevelVo>({
    url: "/api/lm/alliance/contribution/pageAllianceActivityCount",
    data,
  });
}
/**
 * 联盟价格提报统计(分页)
 */
export function getAlliancePriceCount(data: LmContributionPageReqCreate) {
  return post<PageVoLmReportCountVo>({
    url: "/api/lm/alliance/contribution/pageAllianceReportCount",
    data,
  });
}
/**
 * 联盟出勤统计(分页)
 */
export function getAllianceAttendanceCount(data: LmContributionPageReqCreate) {
  return post<PageVoLmAttendanceCountVo>({
    url: "/api/lm/alliance/contribution/pageAllianceAttendanceCount",
    data,
  });
}
/**
 * 联盟成员列表
 */
export function getAllianceMemberList(data: LmMemberPageReq) {
  return post<PageVoLmMemberPageVo>({
    url: "/api/lm/alliance/company/page",
    data,
  });
}
/**
 * 退出联盟
 */
export function exitAlliance() {
  return get({
    url: "/api/lm/alliance/company/exitAlliance",
  });
}
/**
 * 删除联盟成员公司
 */
export function deleteAllianceMember(companyCode: string) {
  return get({
    url: `/api/lm/alliance/company/deleteCompany?companyCode=${companyCode}`,
  });
}
/**
 * 提报项管理列表查询
 */
export function getItemList(data: ReportItemManagePageReq) {
  return post<PageVoLmReportItemManageVo>({
    url: "/api/lm/alliance/report/item/managePage",
    data,
  });
}
/**
 * 批量删除提报项
 */
export function deleteItemList(ids: string[]) {
  return post({
    url: `/api/lm/alliance/report/item/batchDelete`,
    data: ids,
  });
}
/**
 * 新增提报项
 */
export function addItem(data: ReportItemAddReq[]) {
  return post({
    url: "/api/lm/alliance/report/item/add",
    data,
  });
}
/**
 * 编辑提报项
 */
export function editItem(data: LmAdminReportReq) {
  return post({
    url: "/api/lm/alliance/report/item/update",
    data,
  });
}
/**
 * 商品映射分页查询
 */
export function productMappingPage(data: ProductMappingPageReq) {
  return post<PaginationResponse<ProductMappingPageVo[]>>({
    url: "/api/lm/alliance/report/item/mapping/page",
    data,
  });
}
/**
 * 批量删除商品映射
 */
export function batchDeleteMapping(ids: string[]) {
  return post({
    url: `/api/lm/alliance/mapping/batch/delete`,
    data: ids,
  });
}
/**
 * 商品映射导入临时数据批量删除
 */
export function batchDeleteImportTempData(ids: string[]) {
  return post({
    url: `/api/lm/alliance/mapping/batch/delete/temp`,
    data: ids,
  });
}

/**
 * 商品映射导入临时数据分页查询
 */
export function importTempDataPage(data: MappingTempPageReq) {
  return post<PaginationResponse<MappingTempPageVo[]>>({
    url: "/api/lm/alliance/mapping/temp/page",
    data,
  });
}
/**
 * 商品映射导入临时数据更新
 */
export function updateImportTempData(data: MappingTempUpdateReq) {
  return post({
    url: "/api/lm/alliance/mapping/temp/update",
    data,
  });
}
/**
 * 商品映射导入临时数据上传
 */
export function uploadImportTempData(data: FormData) {
  return post({
    url: "/api/lm/alliance/mapping/temp/upload",
    data,
  });
}
/**
 * 商品映射导入临时数据统计
 */
export function getImportTempDataCount() {
  return get<ReportCountVo>({
    url: "/api/lm/alliance/mapping/temp/count",
  });
}
/**
 * 商品映射导入临时数据提交
 */
export function commitImportTempData() {
  return get({
    url: "/api/lm/alliance/mapping/temp/submit",
  });
}
/**批量删除导入问题数据 */
export function batchDelImportData(data: string[]) {
  return post({
    url: `/api/lm/alliance/report/batch/delete`,
    data,
  });
}
/**
 * 查询当前用户是否是唯一联盟管理员
 */
export function getIsUniqueAllianceAdmin() {
  return get<boolean>({
    url: "/api/lm/alliance/company/checkOnlyAdmin",
  });
}
/**
 * SPU 智能匹配
 */
export function getSpuMatch(data: LmSpuMatchReq) {
  return post<LmSpuMatchVo[]>({
    url: "/api/lm/alliance/base/spuMatch",
    data,
  });
}
/* 待确认提醒查询
 */
export function getConfirmReminder() {
  return get<ConfirmReminderVo>({
    url: "/api/lm/alliance/report/item/confirmReminder",
  });
}
/******************实时分析*********************/
/**
 * 访问状态检查
 */
export function checkAccess(data: RealtimeReq) {
  return post<AccessStatusVo>({
    url: "/api/lm/alliance/realTime/accessStatus",
    data,
  });
}
/**
 * 实时分析摘要
 */
export function getSummary(data: DailyReportDetailReq) {
  return post<DailyReportDetailVo>({
    url: "/api/lm/alliance/realTime/detail",
    data,
  });
}
/**
 * 商品成本对比
 */
export function getProductCostComparison(data: DailyReportProductListReq) {
  return post<PaginationResponse<DailyReportProductListVo[]>>({
    url: "/api/lm/alliance/realTime/product/list",
    data,
  });
}
/**
 * 大类成本对比
 */
export function getCategoryCostComparison(data: DailyReportCategoryListReq) {
  return post<PaginationResponse<DailyReportCategoryListVo[]>>({
    url: "/api/lm/alliance/realTime/category/list",
    data,
  });
}
/**
 * 企业提报项列表查询
 */
export function getCompanyReportItemPage(data: CompanyReportItemPageReq) {
  return post<PageVoCompanyReportItemVo>({
    url: "/api/lm/alliance/company/report/item/page",
    data,
  });
}

/******************PDF 导出*********************/
/**
 * 提交导出任务
 */
export function submitExport(data: PdfExportReq) {
  return post<ExportTaskVo>({
    url: "/api/lm/alliance/export/submit",
    data,
  });
}
/**
 * 弹窗任务列表（最多3条）
 */
export function getTaskList(data: ExportTaskReq) {
  return post<ExportTaskPopupVo>({
    url: "/api/lm/alliance/export/popupTasks",
    data,
  });
}
/**
 * 任务列表分页（近90天）
 */
export function getTaskListAll(data: ExportTaskPageReq) {
  return post<PageVoExportTaskVo>({
    url: "/api/lm/alliance/export/taskPage",
    data,
  });
}
/**
 * 获取下载 URL
 */
export function getDownloadUrl(data: ExportTaskReq) {
  return post<string>({
    url: "/api/lm/alliance/export/downloadUrl",
    data,
  });
}
/**
 * 取消生成
 */
export function cancelExport(data: ExportTaskReq) {
  return post({
    url: "/api/lm/alliance/export/cancel",
    data,
  });
}
/**
 * 重试
 */
export function retryExport(data: ExportTaskReq) {
  return post({
    url: "/api/lm/alliance/export/retry",
    data,
  });
}
/**
 * 删除记录
 */
export function deleteExport(data: ExportTaskReq) {
  return post({
    url: "/api/lm/alliance/export/delete",
    data,
  });
}
/**
 * 清空已完成/失败/已取消记录
 */
export function clearExport(data: ExportTaskReq) {
  return post({
    url: "/api/lm/alliance/export/clear",
    data,
  });
}
/**
 * 下载 PDF 文件（二进制流）
 */
export function downloadPdf(id: number) {
  return post({
    url: "/api/lm/alliance/export/download",
    params: { id },
    responseType: "blob",
  });
}
/**
 * 查询可添加到联盟的企业提报项（标记已添加状态）
 */
export function getAvailableForAlliance(data: CompanyReportItemPageReq) {
  return post<PageVoCompanyReportItemVo>({
    url: "/api/lm/alliance/company/report/item/availableForAlliance",
    data,
  });
}

/**
 * 新增企业提报项（已存在则自动覆盖）
 */
export function addCompanyReportItem(data: ReportItemAddReq[]) {
  return post({
    url: "/api/lm/alliance/company/report/item/add",
    data,
  });
}

/**
 * 编辑企业提报项
 */
export function updateCompanyReportItem(data: LmAdminReportReq) {
  return post({
    url: "/api/lm/alliance/company/report/item/update",
    data,
  });
}

/**
 * 批量删除企业提报项
 */
export function batchDeleteCompanyReportItem(ids: string[]) {
  return post({
    url: "/api/lm/alliance/company/report/item/batchDelete",
    data: ids,
  });
}

/**
 * 从企业提报项批量添加为联盟提报项
 */
export function batchAddFromEnterprise(reportCodes: string[]) {
  return post({
    url: "/api/lm/alliance/report/item/batchAddFromEnterprise",
    data: reportCodes,
  });
}
/**
 * 更新模式 0-提报人自选模式，1-管理员配置
 */
export function updateMode(type: number) {
  return get({
    url: "/api/lm/alliance/report/item/updateMode",
    params: { type },
  });
}
/**
 * 获取一级类目
 */
export function getFirstCategory() {
  return get<LmCategoryVo[]>({
    url: "/api/lm/alliance/base/getAllFirstLevelCategory",
  });
}

/******************周期报告（周报/月报）*********************/
/**
 * 周期报告日期列表
 * @returns 月份日期列表
 */
export function getPeriodReportDate(data: { reportType: number }) {
  return get<PeriodReportDateVo[]>({
    url: '/api/lm/alliance/period/report/date',
    params: data,
  });
}

/**
 * 周期报告列表
 * @returns 分页报告列表
 */
export function getPeriodReportList(data: PeriodReportListReq) {
  return post<AppPaginationResponse<PeriodReportListVo[]>>({
    url: '/api/lm/alliance/period/report/list',
    data,
  });
}

/**
 * 周期报告详情
 * @returns 报告详情
 */
export function getPeriodReportDetail(data: PeriodReportDetailReq) {
  return post<DailyReportDetailVo>({
    url: '/api/lm/alliance/period/report/detail',
    data,
  });
}

/**
 * 周期报告大类明细
 * @returns 分页大类列表
 */
export function getPeriodReportDetailCategory(data: PeriodReportCategoryListReq) {
  return post<PaginationResponse<DailyReportCategoryListVo[]>>({
    url: '/api/lm/alliance/period/report/category/list',
    data,
  });
}

/**
 * 周期报告商品明细
 * @returns 分页商品列表
 */
export function getPeriodReportDetailProduct(data: PeriodReportProductListReq) {
  return post<PaginationResponse<DailyReportProductListVo[]>>({
    url: '/api/lm/alliance/period/report/product/list',
    data,
  });
}
